import Component from "./OrganizationBasicDetails";
export default Component;
